var map = {
	"./bg-bigpromotion.png": 91163,
	"./bg-deposit.png": 63934,
	"./bg-giftbox.png": 58325,
	"./bg-group-tag.png": 23866,
	"./bg-group.png": 72605,
	"./bg-quickbuy.png": 18217,
	"./bg-vip.png": 78057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21373;